var _g, _line, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodtoFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "212px",
    height: "232px",
    viewBox: "0 0 565.1 619",
    enableBackground: "new 0 0 565.1 619",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 72.9,
    y1: 100.6,
    x2: 72.9,
    y2: 594.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,103.2 72.9,87.7 81.9,103.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "63.9,591.9 72.9,607.4 81.9,591.9  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3.0317,
    x1: 0,
    y1: 607.4,
    x2: 480,
    y2: 607.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M489.9,610.4v-14.7h9.6v1.6h-7.8v4.7h7.6v1.6h-7.6v6.7H489.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M501.7,610.4v-14.7h1.8v13h6.8v1.6H501.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513.1,607c-0.6-1.2-0.9-2.4-0.9-3.9s0.3-2.7,0.9-3.9c0.6-1.2,1.5-2.1,2.6-2.7c1.1-0.7,2.4-1,3.8-1 c1.4,0,2.7,0.3,3.8,1c1.1,0.7,2,1.6,2.6,2.7c0.6,1.2,0.9,2.4,0.9,3.9s-0.3,2.7-0.9,3.9c-0.6,1.2-1.5,2.1-2.6,2.7 c-1.1,0.7-2.4,1-3.8,1c-1.4,0-2.7-0.3-3.8-1C514.6,609.1,513.7,608.2,513.1,607z M514.1,603.1c0,1.1,0.2,2.1,0.7,3.1 c0.4,0.9,1.1,1.6,1.9,2.1c0.8,0.5,1.8,0.8,2.8,0.8s2-0.3,2.9-0.8c0.8-0.5,1.5-1.2,1.9-2.1s0.7-1.9,0.7-3.1c0-1.7-0.5-3.2-1.5-4.3 c-1-1.1-2.3-1.7-3.9-1.7c-1.6,0-2.9,0.6-3.9,1.7C514.6,600,514.1,601.4,514.1,603.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M530,607c-0.6-1.2-0.9-2.4-0.9-3.9s0.3-2.7,0.9-3.9c0.6-1.2,1.5-2.1,2.6-2.7c1.1-0.7,2.4-1,3.8-1 c1.4,0,2.7,0.3,3.8,1c1.1,0.7,2,1.6,2.6,2.7c0.6,1.2,0.9,2.4,0.9,3.9s-0.3,2.7-0.9,3.9c-0.6,1.2-1.5,2.1-2.6,2.7 c-1.1,0.7-2.4,1-3.8,1c-1.4,0-2.7-0.3-3.8-1C531.4,609.1,530.6,608.2,530,607z M530.9,603.1c0,1.1,0.2,2.1,0.7,3.1 c0.4,0.9,1.1,1.6,1.9,2.1c0.8,0.5,1.8,0.8,2.8,0.8s2-0.3,2.9-0.8c0.8-0.5,1.5-1.2,1.9-2.1s0.7-1.9,0.7-3.1c0-1.7-0.5-3.2-1.5-4.3 c-1-1.1-2.3-1.7-3.9-1.7c-1.6,0-2.9,0.6-3.9,1.7C531.4,600,530.9,601.4,530.9,603.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M546.5,610.4v-14.7h5.9c1.4,0,2.5,0.4,3.3,1.2c0.9,0.8,1.3,1.9,1.3,3.2c0,0.6-0.1,1.2-0.3,1.8 c-0.2,0.5-0.5,1-0.9,1.3s-0.8,0.6-1.2,0.8c-0.5,0.2-0.9,0.3-1.4,0.4l4,6H555l-3.7-5.8h-2.9v5.8H546.5z M548.3,603h3.8 c0.9,0,1.6-0.3,2.1-0.8s0.8-1.2,0.8-2s-0.3-1.5-0.8-2s-1.3-0.8-2.1-0.8h-3.8V603z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 138.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 162,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.3,
    y: 78.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 415.3,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 75.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodtoFloor);
export default __webpack_public_path__ + "static/media/RodtoFloor.31cbc35d0788a5ff1e5014532580a398.svg";
export { ForwardRef as ReactComponent };